import config from '@/config/config'
import TabbarLayout from '@/layout/TabbarLayout/index.vue'

/*
  tabShow 是否展示底部导航
  keepAlive 是否需要缓存组件
  noLogin 页面是否开启免登录
	showScrollTop 显示滚动顶部按钮
*/

const visitorMode = Boolean(process.env.VUE_APP_VISITOR_MODE)

const tabbar = [
  {
    path: '/tabbar',
    name: 'Tabbar',
    component: TabbarLayout,
    meta: {
      showHeadBar: false,
      keepAlive: true
    },
    children: [
      {
        path: '/tabbar/home',
        name: 'Home',
        component: () => import('@/views/Home'),
        meta: {
          name: '首页',
          keepAlive: true,
          noLogin: config.visitorMode,
          routerBack: false,
          showScrollTop: true,
          icon: 'home',
          showHeadBar: false
        }
      },
      {
        path: '/tabbar/category',
        name: 'Category',
        component: () => import('@/views/category'),
        meta: {
          name: '分类',
          keepAlive: true,
          noLogin: config.visitorMode,
          routerBack: false,
          icon: 'category',
          showHeadBar: false
        }
      },
      {
        path: '/tabbar/car',
        name: 'Cart',
        component: () => import('@/views/cart'),
        meta: {
          name: '购物车',
          tabShow: true,
          keepAlive: true,
          routerBack: false,
          icon: 'cart',
          showHeadBar: false
        }
      },
      {
        path: '/tabbar/my',
        name: 'My',
        component: () => import('@/views/my'),
        meta: {
          name: '我的',
          tabShow: true,
          routerBack: false,
          icon: 'my',
          showHeadBar: false
        }
      }
    ]
  }
]

export default tabbar
